import React from "react";
import Lock from "../assets/sloth/lock.png";
import Money from "../assets/sloth/money.png";
import Bottle from "../assets/sloth/bottle.png";
import Coin from "../assets/sloth/coin.png";
import { Fade, Roll, Flip } from "react-awesome-reveal";


const UtilityCard = (props) => {
    return(
        <div className="flex flex-col items-center justify-center text-center lg:grid lg:grid-cols-5 lg:text-left gap-x-[24px]">
            <div className="col-span-2">
                <Flip>
                <img src={props.image} className='w-[146.67px] lg:w-full h-full'/>
                </Flip>

            </div>
            <div className="space-y-[8px] lg:col-span-3 lg:h-full flex lg:items-start justify-center flex-col pt-[16px] lg:pt-0">
                <h3 className="subtitle">
                    {props.title}
                </h3>
                <p className="body-2">
                    {props.copy}
                </p>
            </div>
        </div>
    )
}


function LeftLeaf(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-141.95 15.75 283.78 396.31"
        {...props}
      >
        <path
          d="M94.503 305.385l10.77-18.936c-20.528-47.666-46.449-88.542-73.753-122.998l-17.114 34.465 6.355-47.641C-57.255 57.615-141.95 15.749-141.95 15.749c1.387 39.873 6.685 75.9 14.897 108.462l26.478 2.583-23.505 8.542c30.523 109.315 94.322 177.788 151.815 219.243l25.191-6.864-17.584 12.243c57.381 39.479 106.489 52.099 106.489 52.099-6.632-40.867-17.718-80.251-33.076-117.497l-14.253 10.825z"
          fill="#BBF0D2"
        />
        <path
          d="M133.296 404.036S-76.556 207.647-137.047 24.823c0 0 47.919 145.189 270.343 379.213z"
          fill="#E6FFF1"
        />
        <path
          d="M68.542 332.948l-46.157 6.361 42.125-8.158 4.032 1.797zM93.284 360.864l-3.314-26.451 6.391 29.847-3.078-3.396zM32.83 290.797l-3.477-79.012-1.005 76.272 4.482 2.74zM2.452 256.002l-57.188-3.238 52.983-.149 4.205 3.387z"
          fill="#E6FFF1"
        />
      </svg>
    )
  }

  function BottomRightLeaf(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="37.31 34.38 373.26 210.29"
        {...props}
      >
        <g>
          <path
            d="M333.116 104.268l1.44 18.97c-34.117 29.969-69.962 52.564-104.499 69.574l-.649-33.597-12.81 39.983c-96.513 44.033-179.29 45.472-179.29 45.472 16.034-30.961 33.726-57.426 52.427-80.067l21.944 7.844-15.422-15.518c65.126-74.908 141.316-105.152 202.391-116.42l17.386 14.822-9.345-16.229c60.246-9.749 103.877-1.383 103.877-1.383-20.56 29.788-44.095 56.743-70.213 80.415l-7.237-13.866z"
            fill="#0D3727"
          />
          <path
            d="M400.799 40.866s-239.81 76.715-356.21 198.47c0 0 92.344-96.737 356.21-198.47z"
            fill="#0D5137"
          />
          <path
            d="M278.794 92.766l-32.35 61.079 27.773-60.59 4.577-.49zM241.694 108.896l-46.518-18.79L237.094 110l4.6-1.104zM180.031 142.057l-31.143 52.694 35.746-55.712-4.603 3.018zM136.742 165.022l-26.592-8.587 25.583 11.202 1.009-2.615zM104.898 191.014l-9.314 20.953 6.302-22.651 3.012 1.698z"
            fill="#0D5137"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_1021_7584"
            x={23.3086}
            y={20.3792}
            width={401.258}
            height={238.291}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur
              stdDeviation={7}
              result="effect1_foregroundBlur_1021_7584"
            />
          </filter>
        </defs>
      </svg>
    )
  }
  
  

const Utilities = () => {
    return(
        <section className=" pt-[75px] lg:pt-[100px] pb-[70px] lg:pb-[170px] text-[#0D3727] text-center relative">
            <div className="container-theme">
              <Fade cascade duration={300}>
            <h2 className="h2 uppercase">
               Utilities 
            </h2>
            <p className="body-1 pt-[30px] lg:pt-[70px]">
            The SMSC Genesis Sloths, came with amazing traits as well as utilities.
            </p>
            <div className="pt-[70px] grid lg:grid-cols-2 gap-y-[60px] gap-x-[45px]">
            <Fade cascade duration={300}>

                <UtilityCard image={Lock} title={`Breeding & NFT Locking`} copy={`Ability to breed a baby sloth if you have both male & female adult sloths in your wallet, or if you sire with a female.`}/>
                <UtilityCard image={Bottle} title={`Siring`} copy={`If you don’t have both genders, you can buy the opposite gender from the official OpenSea SMSC page.`}/>
                <UtilityCard image={Money} title={`Staking`} copy={`A max of 1,500 baby sloths. These will have second-hand royalties set at 8%.`}/>
                <UtilityCard image={Coin} title={`Community Token`} copy={`The Community Token was going to be liquefied by the 50% of the second-hand royalties of baby sloths, 50% of the siring fee and 25% of the breeding profits.`}/>
            </Fade>
            </div>
            </Fade>
            </div>
            <div className="absolute left-[-150px] w-[350px] h-[350px] top-[10%] hidden lg:block">
                        <LeftLeaf/>
                    </div>
                    <div className="absolute right-[-240px] w-[450px] h-[350px] bottom-[0%] hidden lg:block">

                        <BottomRightLeaf/>
                    </div>



        </section>
    )
}

export default Utilities